import { colors } from '../../styles/colors';
import { Priority } from '../client/store/segments/types';
export interface SVGIconKeys {
  arrowLeft: string;
  book: string;
  bullhorn: string;
  building: string;
  calendar: string;
  calendarCross: string;
  caretLeft: string;
  caretRight: string;
  caretDown: string;
  clock: string;
  close: string;
  cross: string;
  diamond: string;
  edit: string;
  email: string;
  error: string;
  highPriority: string;
  info: string;
  mapMarker: string;
  marker: string;
  mediumPriority: string;
  noPriority: string;
  phone: string;
  plus: string;
  plusCircle: string;
  pricetag: string;
  profile: string;
  segment: string;
  target: string;
  threeDots: string;
  threeBars: string;
  upload: string;
  userX: string;
  users: string;
  organization: string;
  eye: string;
  impersonate: string;
  userPlus: string;
  waypoint: string;
  reorder: string;
  snooze: string;
  home: string;
  search: string;
  settings: string;
  calendarCheck: string;
  forbidden: string;
  circle: string;
}

export const svgIconKeys: { [key in keyof SVGIconKeys]: string } = {
  arrowLeft: 'assets/icons/arrow-left.svg',
  book: 'assets/icons/book.svg',
  bullhorn: 'assets/icons/bullhorn.svg',
  calendar: 'assets/icons/calendar.svg',
  calendarCross: 'assets/icons/calendar-cross.svg',
  caretLeft: 'assets/icons/caret-left.svg',
  caretRight: 'assets/icons/caret-right.svg',
  caretDown: 'assets/icons/caret-down.svg',
  clock: 'assets/icons/clock.svg',
  close: 'assets/icons/close.svg',
  cross: 'assets/icons/cross.svg',
  diamond: 'assets/icons/diamond.svg',
  edit: 'assets/icons/edit.svg',
  email: 'assets/icons/mail.svg',
  error: 'assets/icons/error.svg',
  highPriority: 'assets/icons/high-priority.svg',
  info: 'assets/icons/info.svg',
  mapMarker: 'assets/icons/map-marker.svg',
  marker: 'assets/icons/marker.svg',
  mediumPriority: 'assets/icons/medium-priority.svg',
  noPriority: 'assets/icons/no-priority.svg',
  phone: 'assets/icons/phone.svg',
  plus: 'assets/icons/plus.svg',
  plusCircle: 'assets/icons/plus-circle.svg',
  pricetag: 'assets/icons/pricetag.svg',
  profile: 'assets/icons/profile.svg',
  segment: 'assets/icons/segment.svg',
  target: 'assets/icons/target.svg',
  threeDots: 'assets/icons/three-dots.svg',
  threeBars: 'assets/icons/three-bars.svg',
  upload: 'assets/icons/upload.svg',
  userX: 'assets/icons/user-x.svg',
  users: 'assets/icons/users.svg',
  building: 'assets/icons/building.svg',
  organization: 'assets/icons/organization.svg',
  eye: 'assets/icons/eye.svg',
  impersonate: 'assets/icons/impersonate.svg',
  userPlus: 'assets/icons/user-plus.svg',
  waypoint: 'assets/icons/waypoint.svg',
  reorder: 'assets/icons/reorder.svg',
  snooze: 'assets/icons/snooze.svg',
  home: 'assets/icons/home.svg',
  search: 'assets/icons/search.svg',
  settings: 'assets/icons/settings.svg',
  calendarCheck: 'assets/icons/calendar-check.svg',
  forbidden: 'assets/icons/forbidden.svg',
  circle: 'assets/icons/circle.svg',
};

export const priorityToIconKeyMap = {
  [Priority.NO_PRIORITY]: svgIconKeys.noPriority,
  [Priority.MEDIUM]: svgIconKeys.mediumPriority,
  [Priority.HIGH]: svgIconKeys.highPriority,
};

export const colorToHexMap = {
  green: '#a5cdc4',
  red: '#feb5b5',
  yellow: '#e2c789',
  blue: '#7EC0E5',
  noPriority: colors.blue100,
  mediumPriority: colors.blue200,
  highPriority: colors.blue400,
};

export const mapColorToHexMap = {
  green: '#2cac5f',
  red: '#fb5b5b',
  yellow: '#fec62e',
  noPriority: colors.blue200,
  blue: '#7ec0e5',
};
